import { useCallback } from 'react';

export interface UseOrdersActionButtonsProps {
  onCreateOrder?: () => void;
  onExport?: () => void;
}

export const useOrdersActionButtons = ({
  onCreateOrder,
  onExport,
}: UseOrdersActionButtonsProps = {}) => {
  const handleCreateOrder = useCallback(() => {
    if (onCreateOrder) {
      onCreateOrder();
    }
  }, [onCreateOrder]);

  const handleExport = useCallback(() => {
    if (onExport) {
      onExport();
    }
  }, [onExport]);

  return {
    handleCreateOrder,
    handleExport,
  };
};
